// removed by extract-text-webpack-plugin
module.exports = {"contact":"src-components-contact----styles-module---contact---13_aX","lineBreak":"src-components-contact----styles-module---lineBreak---1yPvS","email":"src-components-contact----styles-module---email---3rLgN","link":"src-components-contact----styles-module---link---3_9I0","social":"src-components-contact----styles-module---social---1BgLN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contact/styles.module.css
// module id = ./src/components/contact/styles.module.css
// module chunks = 88746230898986 102538987983895